// extracted by mini-css-extract-plugin
export var alertButton = "shared-module--alertButton--4bf92";
export var button = "shared-module--button--f4efc";
export var buttonSkeleton = "shared-module--buttonSkeleton--1a9c1";
export var ccOptions = "shared-module--ccOptions--0ca14";
export var depositOptions = "shared-module--depositOptions--9624d";
export var depositOptionsWhite = "shared-module--depositOptionsWhite--87f31";
export var headerSkeleton = "shared-module--headerSkeleton--98f16";
export var interacHeaderSkeleton = "shared-module--interacHeaderSkeleton--38eb6";
export var logo = "shared-module--logo--fb956";
export var logoSkeleton = "shared-module--logoSkeleton--2eb71";
export var pageMessageIcon = "shared-module--pageMessageIcon--cb3b8";
export var skeletonAlert = "shared-module--skeletonAlert--62a48";
export var skeletonLines = "shared-module--skeletonLines--8881b";
export var small = "shared-module--small--3a20c";
export var textSkeleton = "shared-module--textSkeleton--34aff";